// extracted by mini-css-extract-plugin
export var hideEditor = "_lv-2";
export var infoIcon = "_lv-3";
export var label = "_lv-1";
export var labelContainer = "_lv-0";
export var readonlyText = "_lv-4";